<template>
    <div>
        <b-skeleton-wrapper :loading="loading">
            <template #loading>
                <b-card>
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                </b-card>
            </template>
            <b-alert
                :show="classes.length == 0"
            >
                <font-awesome-icon class="mr-2" icon="info-circle"></font-awesome-icon>
                You are not teaching any classes.
            </b-alert>
            <b-card
                v-for="(Class, Index) in classes"
                :key="Index"
                :title="Class.class_name"
                :sub-title="classTime(Class)"
                class="mt-2"
            >
                <span v-if="Class.class_location">
                    <b>Location: </b> <i>{{ Class.class_location }}</i>
                </span>
                <p>{{ Class.description }}</p>
                <class-actions :class_="Class"></class-actions>
            </b-card>
        </b-skeleton-wrapper>
    </div>
</template>
<script>
import ClassActions from './class-actions/ClassActions.vue';
export default {
    components: { ClassActions },
    name: "teacher-classes-list",
    props: [ "classes", "loading" ],
    data() {
        return {
            classes: []
        };
    },
    methods: {
        classTime(Class) {
            if (typeof Class.start_time == "string" && typeof Class.end_time == "string") {
                return this.$moment("2012-12-31T" + Class.start_time).format("h:mm a") + "-" + this.$moment("2012-12-31T" + Class.end_time).format("h:mm a");
            }
            return "";
        }
    }
}
</script>